import { render, staticRenderFns } from "./ProfileChooseAvatar.vue?vue&type=template&id=4287bc98&scoped=true"
import script from "./ProfileChooseAvatar.vue?vue&type=script&lang=js"
export * from "./ProfileChooseAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4287bc98",
  null
  
)

export default component.exports